<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Настройки</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="defaultTrancheYear" class="form-label col-md-3">
          Год
        </label>
        <div class="col-md-9">
          <select v-model="setting.defaultTrancheYear" id="defaultTrancheYear"
                  class="form-select">
            <option :value="null">-- не выбрано --</option>
            <option v-for="(year, index) in years" :key="index" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <label for="defaultTrancheNumber" class="form-label col-md-3">
          Номер транша
        </label>
        <div class="col-md-9">
          <select v-model="setting.defaultTrancheNumber" id="defaultTrancheNumber"
                  class="form-select">
            <option :value="null">-- не выбрано --</option>
            <option v-for="(number, index) in numbers" :key="index" :value="number">
              {{ number }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="page-footer justify-content-end">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import settingsService from "@/services/settingsService";

export default {
  components: {
    VueLoading
  },
  computed: {},
  data() {
    return {
      isLoading: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      years: Array.from({length: 6}, (v, i) => 2024 + i),
      numbers: Array.from({length: 4}, (v, i) => 1 + i),
    };
  },
  methods: {
    async load() {
      this.isLoading = true;
      this.setting = await settingsService.load();
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.setting = await settingsService.save(this.setting);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
